module.exports = __webpack_public_path__ + "static/media/banner.5590bcc8.jpeg";